// extracted by mini-css-extract-plugin
export var gradient = "styles-module--gradient--PhSze";
export var layout = "styles-module--layout--FR5Ww";
export var layout_content = "styles-module--layout_content--YIW-r";
export var layout_header = "styles-module--layout_header--su9Hz";